/**
 * Toast hook for notifications using react-hot-toast
 */

import { useCallback } from 'react';
import toast from 'react-hot-toast';

export interface ToastOptions {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success';
  duration?: number;
}

export function useToast() {
  const showToast = useCallback((options: ToastOptions) => {
    const variant = options.variant || 'default';
    const message = `${options.title}${options.description ? ': ' + options.description : ''}`;
    const duration = options.duration || 4000;

    if (variant === 'destructive') {
      toast.error(message, { duration });
    } else if (variant === 'success') {
      toast.success(message, { duration });
    } else {
      toast(message, { duration });
    }
  }, []);

  return { toast: showToast };
}